import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
// @ts-expect-error - popups service has no TypeScript declarations
import { usePopups } from 'src/lib/popups';

import { DeleteCommentPopup } from './DeleteCommentPopup';

const DELETE_COMMENT_POPUP = Symbol('DELETE_COMMENT');

/** Resolves with `true` when the user confirms. */
export const useDeleteCommentPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(DELETE_COMMENT_POPUP, DeleteCommentPopup);
  });

  return useCallback(
    (replyCount: number): Promise<boolean> =>
      new Promise((resolve) => {
        popups.openPopup(DELETE_COMMENT_POPUP, {
          replyCount,
          onClose: (confirmed: boolean) => {
            popups.closePopup(DELETE_COMMENT_POPUP);
            resolve(confirmed);
          },
        });
      }),
    [popups]
  );
};
